import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button, Flex, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'

export const ModalSectionType = {
  Add: 'Add',
  Edit: 'Edit'
}

export const ModalSection = ({ modalType, isOpen, onClose, section, handleAdd, handleEdit, isSubmitting }) => {
  const [title, setTitle] = useState('')

  useEffect(() => {
    setTitle(section?.title ?? '')
  }, [section])

  const onCancel = () => {
    onClose()
  }

  const handleChange = (e) => {
    setTitle(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (modalType === ModalSectionType.Add) {
      handleAdd({ title })
    } else {
      handleEdit({ id: section.id, title, sort: section.sort })
    }
  }

  return (
    <>
      <Modal size="xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit}>
            <ModalHeader>{modalType === ModalSectionType.Add ? 'Add' : 'Edit'} Section</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl isRequired>
                <FormLabel>Title</FormLabel>
                <Input type="text" name="title" value={title} onChange={handleChange} />
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Flex justifyContent="flex-end" columnGap={2}>
                {modalType === ModalSectionType.Add && (
                  <Button type="submit" size="sm" colorScheme="blue" isLoading={isSubmitting}>Add</Button>
                )}
                {modalType === ModalSectionType.Edit && (
                  <Button type="submit" size="sm" colorScheme="blue" isLoading={isSubmitting}>Save</Button>
                )}
                <Button size="sm" colorScheme="gray" onClick={onCancel}>Cancel</Button>
              </Flex>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  )
}

ModalSection.propTypes = {
  modalType: PropTypes.oneOf(Object.values(ModalSectionType)).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  section: function (props, propName, componentName) {
    if (props.modalType === ModalSectionType.Edit) {
      if (!props[propName]) {
        return new Error(
          `The prop \`${propName}\` is required when modalType is ${ModalSectionType.Edit} in ${componentName}.`
        )
      }
    }
  },
  handleAdd: PropTypes.func,
  handleEdit: PropTypes.func,
  isSubmitting: PropTypes.bool
}

export const ModalRemoveSection = ({ section, isSubmitting, handleRemove, isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Remove Section</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Are you sure to remove the section - {section?.title}?</Text>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme='red' mr={3} onClick={() => handleRemove(section?.id)} isLoading={isSubmitting}>
            Remove
          </Button>
          <Button variant='ghost' onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ModalRemoveSection.propTypes = {
  section: PropTypes.object,
  isSubmitting: PropTypes.bool,
  handleRemove: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}
